<template>
  <div class="history">
    <div class="top">
      <div class="title">历史记录</div>
      <div class="top-r">
        <span class="item" v-for="(item, index) in dataType" :key="index"
          ><span class="dot" :style="{ backgroundColor: item.color }"></span
          ><span>{{ item.name }}</span></span
        >
      </div>
    </div>
    <div class="list" v-if="data.length">
      <div class="list-item" v-for="(item, index) in data" :key="index">
        <div
          class="dot"
          :class="{
            'dot-1': item.data_source == 2,
            'dot-2': [1, 4, 5, 7].indexOf(item.data_source) >= 0,
            'dot-3': [3, 6].indexOf(item.data_source) >= 0
          }"
        ></div>
        <div class="item-right">
          <span class="time">{{ item.create_time }}</span>
          <span class="num">{{ item.data_value }} {{ unit }}</span>
          <div v-if="showEdit">
            <van-popover
              v-if="item.can_edit"
              v-model="item.showPopover"
              trigger="click"
              placement="left-start"
              :offset="[0, 16]"
            >
              <div class="p-list">
                <div class="p-item" @click="onSelect(item, 0)">
                  <img
                    class="icon"
                    src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/4dee2657308857ad667a06adbf45d546.png"
                    alt=""
                  />
                  <span class="">编辑</span>
                </div>
                <div class="p-item" @click="onSelect(item, 1)">
                  <img
                    class="icon"
                    src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/4277fd2165515ce6628ccefb9f1bc3b7.png"
                    alt=""
                  />
                  <span class="">删除</span>
                </div>
              </div>
              <template #reference>
                <span
                  class="iconfont icon-gengduo1"
                  :class="{ 'iconfont-active': item.showPopover }"
                ></span>
              </template>
            </van-popover>
            <div class="iconfont" v-else></div>
          </div>
        </div>
      </div>
    </div>
    <div class="not-data" v-else>暂无数据</div>
    <div class="finished" v-if="data.length && finished">没有更多了</div>
    <AppRuler
      v-model="showRuler"
      :title="'修改' + title"
      :unit="unit"
      :oneGridValue="rulerOptions.oneGridValue"
      :defaultNum="rulerOptions.defaultNum"
      :maxNum="rulerOptions.max"
      :minNum="rulerOptions.min"
      @confirm="bindConfirm"
    />
  </div>
</template>
<script>
import AppRuler from '@/components/app/ruler/index.vue'
export default {
  components: {
    AppRuler
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    finished: {
      type: Boolean,
      default: false
    },
    unit: {
      type: String,
      default: 'KG'
    },
    field: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    rulerOptions: {
      type: Object,
      default: null
    }
  },
  inject: ['addRecord'],
  data() {
    return {
      showRuler: false,
      dataType: [
        {
          name: '馆测',
          color: '#6d52ab'
        },
        {
          name: '自测',
          color: '#ad96ff'
        },
        {
          name: '减脂营体测',
          color: '#ff8e8e'
        }
      ]
    }
  },
  computed: {
    showEdit() {
      //只能编辑体重和腰围
      return ['weight', 'waist'].includes(this.field)
    }
  },
  methods: {
    onSelect(item, index) {
      /* if (!this.$betterwe.isApp()) {
        return
      } */
      item.showPopover = false
      switch (index) {
        case 0:
          this.editData(item)
          break
        case 1:
          this.showDelToast(item)
          break
      }
    },
    editData(item) {
      this.curEditData = item
      let rulerOptions = Object.assign(
        {
          title: this.title,
          unit: this.unit
        },
        this.rulerOptions
      )
      rulerOptions.defaultNum = +item.data_value
      this.addRecord(rulerOptions, this)
    },
    bindConfirm(value) {
      let params = {
        id: this.curEditData.id,
        field: this.field,
        value: value
      }
      this.$http.postApp('member/UserBodyData/edit', params).then((res) => {
        res = res.data
        if (res.code == 200) {
          this.$toast('修改成功')
          this.$parent &&
            this.$parent.editRecord &&
            typeof this.$parent.editRecord == 'function' &&
            this.$parent.editRecord(this.curEditData.id, value)
        } else {
          this.$toast(res.msg)
        }
      })
    },
    showDelToast(item) {
      this.$dialog
        .confirm({
          title: '确认清除该数据吗？',
          message: '（数据清除后不可恢复）'
        })
        .then(() => {
          this.delRecord(item)
          // on confirm
        })
        .catch(() => {
          // on cancel
        })
    },
    delRecord(item) {
      let params = {
        id: item.id
      }
      this.$http.postApp('member/UserBodyData/delete', params).then((res) => {
        res = res.data
        if (res.code == 200) {
          this.$toast('删除成功')
          this.$parent &&
            this.$parent.delRecord &&
            typeof this.$parent.delRecord == 'function' &&
            this.$parent.delRecord(item.id)
        } else {
          this.$toast(res.msg)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.history {
  width: 100%;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 12px;
  padding: 15px 20px;

  .top {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .title {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #000000;
      line-height: 22px;
    }

    .top-r {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.7);
      line-height: 17px;
      display: flex;
      justify-content: flex-end;

      .item {
        margin-right: 9px;
        display: flex;
        align-items: center;

        .dot {
          display: inline-block;
          width: 11px;
          height: 11px;
          border-radius: 50%;
          background: #ad96ff;
          margin-right: 3px;
        }

        .dot1 {
          background: #6d52ab;
        }

        .dot2 {
          background: #ad96ff;
        }

        .dot3 {
          background: #ff8e8e;
        }
      }

      .item:last-child {
        margin-right: 0px;
      }
    }
  }

  .list {
    .list-item {
      display: flex;
      align-items: center;

      .dot {
        width: 11px;
        height: 11px;
        background: #ad96ff;
        margin-right: 14px;
        border-radius: 50%;
      }

      .dot-1 {
        background: #6d52ab;
      }

      .dot-2 {
        background: #ad96ff;
      }

      .dot-3 {
        background: #ff8e8e;
      }

      .item-right {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        padding: 12px 0px;
        border-bottom: 1px dashed #e7e7e7;
        display: flex;
        align-items: center;

        .time {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.7);
          line-height: 17px;
          margin-right: 10px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .iconfont {
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          color: #d8d8d8;
        }

        .iconfont-active {
          background: rgba(0, 0, 0, 0.05);
          border-radius: 4px;
        }

        .num {
          font-size: 12px;
          font-family: DIN-Medium, DIN;
          font-weight: 500;
          color: #333333;
          line-height: 15px;
          margin-right: 14px;
        }
      }
    }

    .list-item:last-child {
      .item-right {
        border-bottom: none;
      }
    }
  }
}

.not-data {
  text-align: center;
  font-size: 14px;
  margin: 20px 0px;
  color: rgba(0, 0, 0, 0.5);
}

.finished {
  text-align: center;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
}

.p-list {
  .p-item {
    padding: 6px 22px 6px 33px;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 20px;
    border-bottom: 1px solid #f1f1f1;

    .icon {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }

  .p-item:last-child {
    border-bottom: none;
  }
}
</style>
